
export const UserBotEN = [
  [
    {
      balloon: 'Our relationship isn’t working. And, it’s not me... it’s you! '
    }
  ],
  [
    {
      balloon: 'Icecaps are melting <span class="emoji">🏔️ 🏔️ ➡️ 💦</span>'
    },
    {
      balloon: 'Forests are burning <span class="emoji">🌲 🌲 🌲 ➡️ 🔥</span>'
    },
    {
      balloon: 'Animals are dying <span class="emoji">🐧 🐳 🐯 🐘 ➡️ 😵</span>' 
    },
    {
      balloon: 'Do you care about our problems? Because they’re not just mine...' 
    }
  ],
  [
    {
      balloon: 'Says the one who wants to leave me for Mars...<span class="emoji">🙄</span>'
    }
  ],
  [
    {
      balloon: 'I know, I was kidding. Here’s how we can fix this! <span class="emoji">💪</span>'
    }
  ],
  [
    {
      balloon: 'One way to <span class="emoji">🛑</span> climate change...'
    },
    {
      balloon: 'is to fix our relationship with <span class="emoji">🥒 🧀 🍕🍦</span>'
    }
  ],
  [
    {
      balloon: 'Yes! Most of the problems are actually linked to the food you eat <span class="emoji">😞</span>',
      toggleAvatar: true
    },
    {
      balloon: 'So today I’ll tell you how you can open your mind <span class="emoji">🧠</span> before your mouth <span class="emoji">👄</span>'
    },
    {
      balloon: 'Ready?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">🧑‍🏫</span> Let’s begin with some quick puzzles to satisfy your hunger for knowledge!'
    },
    {
      balloon: 'Many of you think the biggest problem we have with food is not having enough... But what do YOU think?'
    },
    {
      balloon: 'Do more people suffer from obesity or undernutrition? '
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> While more than 690 million people suffer from undernutrition, 2.1 billion people are obese or overweight.',
      balloonWrong: '<span class="emoji">👎</span> Although more than 690 million people suffer from undernutrition, 2.1 billion people are obese or overweight. '
    },
    {
      balloon: 'See, even though lots of people don’t have enough food... Many more have wayyyy too much! ',
      balloonWrong: 'See, even though lots of people don’t have enough food... Many more have wayyyy too much! '
    }
  ],
  [
    {
      balloon: 'And that’s just the tip of the iceberg... Let’s try this one:'
    },
    {
      balloon: 'Do you think we should be wasting food <span class="emoji">🗑️</span>'
    },
    {
      balloon: 'or feeding hungry people ?'
    }
  ],
  [
    {
      balloon: 'I’m glad YOU feel that way, but...'
    },
    {
      balloon: 'How much food do you think is wasted or lost each year?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> Sadly, that’s right...',
      balloonWrong: '<span class="emoji">👎</span> Sadly, it’s more, much more...'
    },
    {
      balloon: 'Every year, 1.3 billion tons make up <span class="emoji">⛰️⛰️⛰️</span> of food that are thrown away or lost from production to the fridge, without even making it to the table',
      balloonWrong: 'Every year, 1.3 billion tons make up <span class="emoji">⛰️⛰️⛰️</span> of food that are thrown away or lost from production to the fridge, without even making it to the table.'
    }
  ],
  [
    {
      balloon: 'That food is not only enough to feed everyone, but it can also help feed everyTHING.'
    },
    {
      balloon: 'Because we are not the only ones who eat food... This brings us to the next question:'
    },
    {
      balloon: 'Should we feed <span class="emoji">🤝‍🧑</span> ,<span class="emoji">🐖 🐄</span> , or <span class="emoji">🚗 🚗</span> ?'
    }
  ],
  [
    {
      balloon: 'Oh yes they do!'
    },
    {
      balloon: 'Only 67% of the world’s cereal production actually goes towards feeding people.'
    },
    {
      balloon: 'The other 24% is used to feed animals and 9% goes towards making biofuel to power industries and vehicles, like your hungry cars.'
    }
  ],
  [
    {
      balloon: 'I know <span class="emoji">😔</span>'
    },
    {
      balloon: 'That’s because they represent some of the global problems you humans are facing today! Which are wayyyy too big for one <span class="emoji">🧑</span> and a <span class="emoji">🌍</span> to solve alone...'
    }
  ],
  [
    {
      balloon: '<span class="emoji">👫</span> TEAMWORK! <span class="emoji">👫</span>'
    },
    {
      balloon: 'Living sustainably and healthy and respecting each other is something we ALL have to do...'
    },
    {
      balloon: 'TOGETHER!'
    },
    {
      balloon: 'Thankfully many nations and citizens have come together to set common goals for a better future that can help us live in a sustainable way, resetting the food system from farm <span class="emoji">🧑‍🌾</span> to fork <span class="emoji">🍴</span> '
    },
    {
      balloon: 'Want to see what makes me a proud home planet? <span class="emoji">😍</span>'
    }
  ],
  [
    {
      balloon: 'It’s time to work together to build a better future, one goal at a time!'
    },
    {
      balloon: 'Discover how food is an important factor in helping us achieve them.'
    },
    {
      balloon: 'SDGS'
    }
  ],
  [
    {
      balloon: 'As you can see, smart personal behaviors are very important! It’s not just understanding the problems we face, but also understanding that all together we can contribute to the change you want to see in the world!'
    }
  ],
  [
    {
      balloon: 'Not so fast! <span class="emoji">✋</span>'
    },
    {
      balloon: 'These are just goals for <b>ALL</b> of humanity, but we still need <b>YOU</b> to do your part to achieve them.'
    },
    {
      balloon: 'LOGOANIM'
    },
    {
      balloon: 'Are you ready to see how <b>YOU</b> can help?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">👷</span>  Now that you’ve built a solid foundation to repair our relationship with food, maybe you can help build more sustainable, healthier and happier cities and communities!'
    },
    {
      balloon: '<span class="emoji">👀</span>  But watch out! <span class="emoji">👀</span>  Feeding an entire city isn’t easy. <span class="emoji">😰</span>'
    },
    {
      balloon: 'More and more people are living in cities that are becoming bigger and bigger every day... How is this impacting the relationship '
    },
    {
      balloon: 'Find out by trying to answer these questions! '
    }
  ],
  [
    {
      balloon: 'Where do most people in the world live today?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> In 2019, 55% of the world’s population lived in cities.<br/>This is an important problem because 2.5 billion people will move to cities in the next 30 years. Cities and surrounding rural areas need to work hand in hand to ensure healthy and sustainable food systems.',
      balloonWrong: '<span class="emoji">👎</span> In 2019, 55% of the world’s population lived in cities.<br/>This is an important problem because 2.5 billion people will move to cities in the next 30 years. Cities and surrounding rural areas need to work hand in hand to ensure healthy and sustainable food systems.'
    },
    {
      balloon: 'How many people will live in cities in 2050? ',
      balloonWrong: 'How many people will live in cities in 2050? '
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> In 2050, almost 70% of the world’s population (estimated at 10 billion people) will live in cities, particularly in Asia and Africa. This will help change the way in which food will be produced, distributed, sold, and consumed. ',
      balloonWrong: '<span class="emoji">👎</span> In 2050, almost 70% of the world’s population (estimated at 10 billion people) will live in cities, particularly in Asia and Africa. This will help change the way in which food will be produced, distributed, sold, and consumed. '
    },
    {
      balloon: 'How many megacities (cities with more than 10 million inhabitants) will there be in 2030? ',
      balloonWrong: 'How many megacities (cities with more than 10 million inhabitants) will there be in 2030? '
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> We already have 33 megacities, and by 2030 the amount of megacities are projected to surpass 40 with most of them being located in Asia and Africa. ',
      balloonWrong: '<span class="emoji">👎</span> We already have 33 megacities, and by 2030 the amount of megacities are projected to surpass 40 with most of them being located in Asia and Africa. '
    },
    {
      balloon: 'How many people in New York City suffer from food insecurity due to COVID-19? ',
      balloonWrong: 'How many people in New York City suffer from food insecurity due to COVID-19? '
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> The COVID-19 pandemic has caused 2 million people in New York City to be without a stable and sustainable amount of food. This shows that our already weak food distribution isn’t anywhere near equipped for unforeseen circumstances such as a global pandemic and needs to be fundamentally changed to ensure no one goes hungry! ',
      balloonWrong: '<span class="emoji">👎</span> The COVID-19 pandemic has caused 2 million people in New York City to be without a stable and sustainable amount of food. This shows that our already weak food distribution isn’t anywhere near equipped for unforeseen circumstances such as a global pandemic and needs to be fundamentally changed to ensure no one goes hungry! '
    },
    {
      balloon: 'What is a food bank? ',
      balloonWrong: 'What is a food bank? '
    }
  ],
  [
    {
      balloon: '<span class="emoji">👍</span> A non-profit food bank is an organization that distributes food to those who have difficulty buying enough to avoid hunger. Food banks are also a solution to reduce waste directly within cities while activating virtuous partnerships between the public and private sectors. ',
      balloonWrong: '<span class="emoji">👎</span> A non-profit food bank is an organization that distributes food to those who have difficulty buying enough to avoid hunger. Food banks are also a solution to reduce waste directly within cities while activating virtuous partnerships between the public and private sectors. '
    },
    {
      balloon: '👏 Now that you’ve learned how to feed a whole city, let’s see how you can feed yourself in a way that’s good for you and good for me. <span class="emoji">😉</span> Are you ready to take a trip to the great pyramids? <span class="emoji">✈️</span>',
      balloonWrong: '👏 Now that you’ve learned how to feed a whole city, let’s see how you can feed yourself in a way that’s good for you and good for me. <span class="emoji">😉</span> Are you ready to take a trip to the great pyramids? <span class="emoji">✈️</span>'
    }
  ],
  [
    {
      balloon: 'Ready?'
    }
  ],
  [
    {
      balloon: 'Now that you’ve learned the good foods from the ones you should consume moderately, let’s put that knowledge to the test by taking you to the restaurant that serves foods the best! '
    }
  ],
  [
    {
      balloon: 'I think we’ve done a good job exploring how food needs to be thought about before putting them in your mouth.'
    },
    {
      balloon: 'Do you think you’re ready to make the daily commitment to eat more and more healthy foods? '
    }
  ],
 [
    {
      balloon: "But wait there's more! You're mission doesn't end here!"
    },
    {
      balloon: "The best thing you can do to keep me happy and both of us healthy... "
    },
    {
      balloon: "Is to spread the word to your family and friends at school about food and me, the planet! "
    },
    {
      balloon: "Because every voice and every action make the difference for our future! "
    }
  ],
  [
    {
      balloon: 'Yes, we have to learn how to live together 😂'
    }
  ] 
]